import { useState } from 'react';
import { useStore } from '../state/store';

export function ReviewQueue() {
  const { events, rows, ingestLine } = useStore((s) => ({
    events: s.events,
    rows: s.rows,
    ingestLine: s.ingestLine,
  }));
  const [draft, setDraft] = useState<Record<string, string>>({});

  // Outstanding only: fixing a fragment resolves it server-side and it
  // leaves this list (and the export's Review queue tab) for good.
  const unparsed = events.filter((e) => e.eventType === 'unparsed' && !e.resolvedAt);
  const flagged = rows.filter((r) => r.validationWarnings.length > 0 || r.status === 'amended');

  async function reingest(id: string, original: string) {
    const text = (draft[id] ?? original).trim();
    if (!text) return;
    await ingestLine(text, id);
    setDraft((d) => { const { [id]: _drop, ...rest } = d; return rest; });
  }

  return (
    <div className="review">
      <section>
        <h2>Unparsed lines ({unparsed.length})</h2>
        <p className="review-help">
          Lines without a recognisable time expression. Edit and resubmit, or
          add a time like <code>two units</code>.
        </p>
        <ul className="review-list">
          {unparsed.length === 0 && <li className="review-empty">Nothing to review.</li>}
          {unparsed.map((e) => (
            <li key={e.id}>
              <input
                value={draft[e.id] ?? e.rawText}
                onChange={(ev) => setDraft({ ...draft, [e.id]: ev.target.value })}
              />
              <span className="review-reason">{e.newValue}</span>
              <button onClick={() => void reingest(e.id, e.rawText)}>Re-ingest</button>
            </li>
          ))}
        </ul>
      </section>
      <section>
        <h2>Rows with warnings or amendments ({flagged.length})</h2>
        <ul className="review-list">
          {flagged.length === 0 && <li className="review-empty">Nothing to review.</li>}
          {flagged.map((r) => (
            <li key={r.id}>
              <span className="row-num">#{r.rowNumber}</span>
              <span className="review-desc">{r.description}</span>
              <span className="review-time">{r.units}u / {r.decimalTime}</span>
              <span className="review-status">{r.status}</span>
              <span className="review-warns">{r.validationWarnings.join('; ')}</span>
            </li>
          ))}
        </ul>
      </section>
    </div>
  );
}
